{
  "$note": "25 TON-097: the words of the first-minute decision (ONB-09; 23 SCR-083; 14 CMP-494). Fixed strings in no caddie's voice. They never say how long it takes, never count down, never name a price or a reward and never ask the player to sign in. The keys marked 'added' below are not in TON-097's table and are the builder's, reported to the founder: the choice words of the two answers with a worth (TON-097 points at TON-098's report.choice.*, which has no phrase for either), the costs forms (TON-097 says to use TON-098's), the twist's heading and rest's line, and the screen's own labels and states. The 'set_up' block is ONB-04's (23 ONB-04; 24 DES-401): TON-097 has no row for it, so its words are the builder's, written to 25 §3.2 and reported to the founder; the three view names and the first two lines are SYS-08's, as the design system's Settings → Views reference screen shows them (24 DES-400, DES-401); Large & clear's line is made shorter to read at grade 7 (TON-004).",
  "title": "Saturday's medal",
  "golfer": "{golferName}, handicap {handicap}",
  "golfer_note": "A ready-made golfer. You make your own next.",
  "question": "Saturday's medal is in two days. How should {golferName} spend them?",
  "answers_label": "How should {golferName} spend the two days?",
  "answer": {
    "range": "Range work",
    "study": "Study the course and play a practice round",
    "rest": "Rest"
  },
  "go": "Play the medal",
  "skip": "Make my golfer first",
  "playing": "The game is playing Saturday's medal.",
  "board_label": "Leaderboard, Saturday's medal, net to par",
  "board": {
    "position": "Pos",
    "golfer": "Golfer",
    "net": "Net",
    "holes": "Holes"
  },
  "your_answer": "Your answer: {answer}",
  "board_open": "See the leaderboard",
  "board_close": "Hide the leaderboard",
  "result": "{golferName}: {position}, net {net}.",
  "worth": "For a golfer like {golferName}, {choiceWords} saves about {worth} shots a round.",
  "worth_today": "For a golfer like {golferName}, {choiceWords} saves about {worth} shots a round. Today it saved {today, plural, one {1 shot} other {# shots}}.",
  "costs": "For a golfer like {golferName}, {choiceWords} costs about {worth} shots a round.",
  "costs_today": "For a golfer like {golferName}, {choiceWords} costs about {worth} shots a round. Today it cost {today, plural, one {1 shot} other {# shots}}.",
  "too_small": "For a golfer like {golferName}, {choiceWords} makes too small a difference to say.",
  "choice": {
    "range": "range work",
    "study": "studying the course and playing a practice round"
  },
  "twist": {
    "heading": "The other two answers",
    "rest": "Rest is what the other answers are measured against."
  },
  "how": {
    "label": "How is this worked out?",
    "body": "Each answer was played in many medals with the same luck, with and without it, for a golfer like {golferName}. One round on its own cannot tell which answer is better."
  },
  "end": {
    "line": "That is the game: you decide, and the game plays the golf.",
    "next": "Make my golfer"
  },
  "offline": "You are offline. Nothing is lost: try again when you are back online.",
  "error": "The medal could not be played just now.",
  "retry": "Try again",
  "welcome": {
    "title": "{gameName}",
    "line": "You run a golfer's life. The game plays the golf.",
    "play_now": "Play now",
    "sign_in": "Sign in"
  },
  "set_up": {
    "title": "Make the game easy to read",
    "line": "Pick what suits you. You can change it any time in Settings.",
    "view_heading": "View",
    "view_line": "Each view changes only how things look, never the golf.",
    "view": {
      "standard": {
        "name": "Standard",
        "line": "The usual look."
      },
      "simple_bright": {
        "name": "Simple & bright",
        "line": "Bigger icons, brighter signposts, fewer numbers."
      },
      "large_clear": {
        "name": "Large & clear",
        "line": "Bigger text and buttons, with stronger outlines."
      }
    },
    "preview": {
      "label": "Preview: {view}",
      "heading": "Today",
      "plan": "Range work",
      "plan_detail": "One hour",
      "checkin": "Check in",
      "checkin_detail": "This morning"
    },
    "text_heading": "Text size",
    "text": {
      "device": "The same as my phone",
      "130": "Bigger (130%)",
      "160": "Biggest (160%)"
    },
    "text_note": "If your phone's own text is bigger, the game keeps your phone's size.",
    "motion_heading": "Movement on screen",
    "motion": {
      "system": "Follow my phone",
      "system_line": "Uses your phone's own setting.",
      "reduced": "Always calmer",
      "reduced_line": "Fades in place of movement."
    },
    "go": "Carry on",
    "done": "Done",
    "settings_link": "Views and text size"
  }
}
